import { render, staticRenderFns } from "./recommendDetail.vue?vue&type=template&id=51eb1671&scoped=true"
import script from "./recommendDetail.vue?vue&type=script&lang=js"
export * from "./recommendDetail.vue?vue&type=script&lang=js"
import style0 from "./recommendDetail.vue?vue&type=style&index=0&id=51eb1671&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb1671",
  null
  
)

export default component.exports